module.exports = __webpack_public_path__ + "img/mapbiomas.5cef4ccf.png";